export const TYPES = {
  SET_BAILIFF_DIALOG_ALL: "bailiff_dialog/SET_BAILIFF_DIALOG_ALL",
  SET_BAILIFF_DIALOG_OPEN_ADD: "bailiff_dialog/SET_BAILIFF_DIALOG_OPEN_ADD",
  SET_BAILIFF_DIALOG_OPEN_EDIT: "bailiff_dialog/SET_BAILIFF_DIALOG_OPEN_EDIT",
  SET_BAILIFF_DIALOG_SELECTED: "bailiff_dialog/SET_BAILIFF_DIALOG_SELECTED",
  SET_BAILIFF_DIALOG_SEARCH: "bailiff_dialog/SET_BAILIFF_DIALOG_SEARCH",
  //
  SET_BAILIFF_DIALOG_URL_AUDIO: "bailiff_dialog/SET_BAILIFF_DIALOG_URL_AUDIO",
  SET_BAILIFF_DIALOG_SECOND: "bailiff_dialog/SET_BAILIFF_DIALOG_SECOND",
  SET_BAILIFF_DIALOG_PLAY: "bailiff_dialog/SET_BAILIFF_DIALOG_PLAY",
  SET_BAILIFF_DIALOG_SLOT: "bailiff_dialog/SET_BAILIFF_DIALOG_SLOT",
  SET_BAILIFF_DIALOG_KICK: "bailiff_dialog/SET_BAILIFF_DIALOG_KICK",
  //
  SET_BAILIFF_DIALOG_GAP: "bailiff_dialog/SET_BAILIFF_DIALOG_GAP",
  SET_BAILIFF_DIALOG_OPEN_SPLIT: "bailiff_dialog/SET_BAILIFF_DIALOG_OPEN_SPLIT",
  SET_BAILIFF_DIALOG_OPTION_SPEAKER:
    "bailiff_dialog/SET_BAILIFF_DIALOG_OPTION_SPEAKER",
  SET_BAILIFF_DIALOG_PREVIEW: "bailiff_dialog/SET_BAILIFF_DIALOG_PREVIEW",
  SET_BAILIFF_DIALOG_MERGED_RAW: "bailiff_dialog/SET_BAILIFF_DIALOG_MERGED_RAW",
  SET_BAILIFF_DIALOG_DRAFT_EDITED:
    "bailiff_dialog/SET_BAILIFF_DIALOG_DRAFT_EDITED",
};
